<template>
    <div class="custom bg-[#23242A]">
        <div v-if="vg_selectedLocation.id" class="flex xl:flex-row flex-col px-4 pt-4 bg-[#23242A] text-white">
            <div class="transition-all duration-100 ease-linear custom-left mr-2" :class="edit.modal?'xl:w-[40%] w-full':'w-full'">
                <product-list :payload="listType.data" :resized="edit.modal" @toggleEdit="toggleEdit" />
            </div>
            <div v-if="edit.modal" class="xl:w-[60%] w-full custom-right transition-all duration-100 ease-linear">
                <edit-product v-if="edit.modal" :editItem="edit.data" :inventory="true" @close="closeEdit" @updatedEditItem="updatedEditItem" />
            </div>
        </div>
        <div v-else class="p-5">
            <div class="flex lg:flex-row flex-col bg-[#2B2C32] rounded-xl"> 
                <div class="w-full">
                    <div class="bg-[#2B2C32] rounded-lg px-8 py-[16px]">
                        <p  class="text-center text-theme-red">Please select a location from the top left corner.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent, reactive, ref} from "vue";
import ProductList from '@/views/Inventory/InventoryOverview/List.vue'
import editProduct from '@/views/Products/Product/Edit/Edit.vue'
import {mapGetters, mapActions, mapMutations} from 'vuex'

export default defineComponent({
    name: "InventoryOverview",
    components: {
        ProductList,
        editProduct
    },
    setup(){
        const listType = ref({
            data: [],
        })
        const edit = ref({
            modal: false,
            data: {}
        })

        return { listType, edit}
    },
    mounted(){
    },
    beforeDestroy(){
    },
    computed: {
        ...mapGetters({
            vg_modified: 'modifiedForm/status',
            vg_selectedLocation: 'location/selected'
        })
    },
    methods: {
        toggleEdit(edit){
           this.edit = edit
        },
         closeEdit(){
            this.edit.modal = false
        },
        updatedEditItem(item){
            this.edit.data = item
        },
         ...mapMutations({
            vm_modified: 'modifiedForm/mutateStatus'
        }),
        ...mapActions({
            va_confirmNew: 'confirmNew/confirmNew'
        })
    }
})
</script>